// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2XyON","rootCenter":"LoadMoreObserver_rootCenter__hE8q_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2tWeo"};